import { options_premium_TransferDomainContent_part1 } from './DomainTransferOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isTransferDomainOptionHidden } from './utils/isTransferDomainOptionHidden';

var lazyFullModule = new LazyModule(() => import('./lazyDomainTransferOption'));
let DomainTransferOption: LazyOption = createLazyOption(
    {
        key: 'domainTransferPageText1',
        titleStringKey: options_premium_TransferDomainContent_part1,
        searchTermsStringKey: options_premium_TransferDomainContent_part1,
        hideTitleInFullOptions: false,
        isHidden: isTransferDomainOptionHidden,
    },
    lazyFullModule,
    m => m.default
);
export default DomainTransferOption;
